export default __webpack_public_path__ + "static/media/date-blue.864ffb4b.svg";